import { useState, useEffect, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Line } from "react-chartjs-2";
// Constants - Functions
import { graphicDataColor1 } from "../../../../config/constants";
import { isAppOrPlus } from "../../../../config/validateApplication";
// Components
import Graphic from "../../../graphic";
import GraphicContainer from "../../../GraphicContainer";

const ScorePlot = forwardRef(({ software, recordings }, ref) => {
  const [positions, setPositions] = useState([]);
  const [scoreValues, setScoreValues] = useState([]);
  const [t] = useTranslation("global");

  useEffect(() => {
    let positions = [];
    let score = [];

    recordings.forEach((recording, i) => {
      positions.push(i + 1);
      score.push(recording.hasOwnProperty("score") ? recording.score : NaN);
    });

    setPositions(positions);
    setScoreValues(score);

    return () => {
      setPositions([]);
      setScoreValues([]);
    };
  }, [recordings]);

  const scoreData = {
    labels: positions,
    datasets: [
      {
        label: t("reports_scoreGraphic_legend1"),
        data: scoreValues,
        backgroundColor: [graphicDataColor1],
        borderColor: [graphicDataColor1],
      },
    ],
  };

  return (
    <GraphicContainer ref={ref}>
      <Graphic
        Title={t("score")}
        Type={Line}
        data={scoreData}
        axisY={t("reports_scoreGraphic_axisY")}
        axisX={t("sessions")}
        graphicDescription={isAppOrPlus(software) ? t("graphics_scoreDescription_AppAndWeb") : t("graphics_scoreDescription_ClinicAndHome")}
        showLegend={false}
      />
    </GraphicContainer>
  );
});

export default ScorePlot;
